/* eslint-disable */
import React, { memo, useEffect } from "react";
import { utility } from "../../../framework/utility/utilityProvider";
import { ApplicationConfigurationKeys, LOCALSTORAGE_KEY, MODULE, PLANNING_VIEW, SOCKET_ACTION, SOCKET_EVENTS } from "../../../framework/constant/constant";
import { useState } from "react";
import { useTranslation } from "../../../locale/useTranslation";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import Avatar from "../../../components/Avatar";
import useSocket from "../../../framework/socket/useSocket";
import { useNavigate } from "react-router";
import bossAIPng from '../../../img/BOSS-AI.png';
import CheckPlanningOverlapOrGapPopup from "../CheckPlanningOverlapOrGapPopup";

export const PlaningFooter = (props) => {

    const { statusMsg, selectedPlanningItemCount, plannerCopiedItemsCount } = props;
    const [activteUsers, setActivteUsers] = useState([]);
    const [showOverlapGapPopup, setShowOverlapGapPopup] = useState(false);
    const durationTypes = ["Nominal", "ActualDuration"];
    const startTypes = ["Nominal", "Actual"];
    const lang = useTranslation();
    const navigate = useNavigate();
    const [isMinified, setIsMinified] = useState(utility.getValue(LOCALSTORAGE_KEY.isMenuMified))
    let user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const enableBossAI = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.EnableBossAI) ?? false;

    useEffect(() => {
        const handleIsMinified = () => {
            setIsMinified(utility.getValue(LOCALSTORAGE_KEY.isMenuMified));
        };

        window.addEventListener('isMinified', handleIsMinified);
        return () => window.removeEventListener('isMinified', handleIsMinified);
    }, []);

    //socket
    const socket = useSocket(SOCKET_EVENTS.onSocketUsers, (socketData) => {
        if (socketData.module != MODULE.PLANNING) return; //no need to filter active user from module 

        switch (socketData.action) {
            case SOCKET_ACTION.ADD_ACTIVE_USER:
            case SOCKET_ACTION.REMOVE_ACTIVE_USER:
                let scheduleActiveUsers = socketData.data.filter((item) => item.module == MODULE.PLANNING);
                console.log(scheduleActiveUsers);
                if (scheduleActiveUsers.length > 0) {
                    const unique = scheduleActiveUsers.filter((obj, index) => {
                        return index === scheduleActiveUsers.findIndex(o => obj?.user?.name === o?.user?.name);
                    });
                    setActivteUsers(unique);
                }
                break;
            default:
                break;
        }
    });
    //for activate user;
    useEffect(() => {
        socket?.emit(SOCKET_EVENTS.onSocketUsers, { action: SOCKET_ACTION.ADD_ACTIVE_USER, module: MODULE.PLANNING, data: { name: user.name, _id: user._id, color: user.color } });

        return () => {

            socket?.emit(SOCKET_EVENTS.onSocketUsers, { action: SOCKET_ACTION.REMOVE_ACTIVE_USER, module: MODULE.PLANNING, data: { name: user.name, _id: user._id, color: user.color } });
        }

    }, []);


    const IconsStyle = (color) => {
        return { color: color, fontSize: "1.0em", size: "1.6em", marginRight: "0.12em" };
    }

    return <>
        <div className={isMinified ? "scheduleFooter scheduleFooterMinified" : 'scheduleFooter'}>
        <div className="row mr-2">

            <div className="col-9" >
                <div className="flex-container" style={{ alignItems: "left", justifyContent: "left" }}>

                    <button title={lang.filter_button_tooltip} type="button" className="btn btn-outline btn-sm" onClick={props.handleChannelFilterDialog}>
                        <i style={IconsStyle("#ffffff")} className="fa fa-filter"></i>
                    </button>

                    <button title={lang.refresh_button_tooltip} type="button" className="btn btn-sm" onClick={props.planningLoading}>
                        <i className="k-icon k-i-reload pb-1" style={IconsStyle("#ffffff")}></i>
                    </button>

                    <button title={lang.planing_preference_button_tooltip} type="button" className="btn btn-outline btn-sm" onClick={props.onOpenPlanningPreference}>
                        <i className="fa fa-cogs" style={IconsStyle("#ffffff")}></i>
                    </button>
                    <button title={lang.check_list_button_tooltip} type="button" className="btn btn-outline btn-sm" onClick={props.onCheckList}>
                        <i className="fa fa-check-circle" style={IconsStyle("#ffffff")}></i>
                    </button>
                    <button title={lang.export_planning_button_tooltip} type="button" className="btn btn-sm" onClick={props.showExcelPopup} >
                        <i className="fa fa-file-export " style={IconsStyle("#ffffff")}></i>
                    </button>
                    <button title={lang.copy_Schedule_button_tooltip} type="button" className="btn btn-sm" onClick={props.onShowCopySchedulePopup} >
                        <i className="fa fa-copy " style={IconsStyle("#ffffff")}></i>
                    </button>
                    <button title={lang.copy_slot_button_tooltip} type="button" className="btn btn-sm" onClick={props.onShowCopySlotPopup} >
                        <i className="fa fa-clipboard" style={IconsStyle("#ffffff")}></i>
                    </button>
                    <button title={lang.check_overlaps_or_gaps_tooltip} type="button" className="btn btn-outline btn-sm" onClick={() => setShowOverlapGapPopup(true)}>
                        <i className="fa fa-exclamation-triangle" style={IconsStyle("#ffffff")}></i>
                    </button>

                    <button title={ enableBossAI ? lang.auto_planning_with_boss_ai_tooltip : lang.auto_planning_tooltip} type="button" className="btn btn-sm" onClick={props.onAutoPlanning} >
                        {enableBossAI ? <div style={{ position: 'relative', width: '26px', height: '26px' }}>
                            <img
                                src={bossAIPng}
                                alt="Boss AI"
                                className=""
                                style={{ width: '26px', height: '26px' }}
                            />
                            <i
                                className="fa fa-brands fa-autoprefixer"
                                style={{
                                    ...IconsStyle("#ffffff"),
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    pointerEvents: 'none',
                                }}
                            ></i>
                        </div> :
                        <i className="fa fa-brands fa-autoprefixer " style={IconsStyle("#ffffff")}></i>}
                    </button>

                    {/* PLANNING VIEW*/}
                    {props.currentPlanningView != PLANNING_VIEW.PLANNER_VIEW && <button title={lang.switch_to_planning_view_tooltip} type="button" className="btn btn-sm" onClick={() => props.setCurrentPlanningView(PLANNING_VIEW.PLANNER_VIEW)} >
                        <i className="fa fa-solid fa-calendar-days" style={IconsStyle("#ffffff")}></i>
                    </button>}

                    {/* SERIES TIMELINE */}
                    {props.currentPlanningView != PLANNING_VIEW.SERIES_TIMELINE_VIEW && <button title={lang.switch_to_series_timeline_view_tooltip} type="button" className="btn btn-sm" onClick={() => props.setCurrentPlanningView(PLANNING_VIEW.SERIES_TIMELINE_VIEW)} >
                        <i className="fa fa-solid fa-timeline" style={IconsStyle("#ffffff")}></i>
                    </button>}

                    <button title={lang.export_missing_segment_mam_report_button_tooltip} type="button" className="btn btn-sm" onClick={props.showMissingSegmentMAMReportPopup} >
                        <i className="fa fa-file" style={IconsStyle("#ffffff")}></i>
                    </button>

                    <button title={lang.mutliple_dummy_insertion_planning_button_tooltip} type="button" className="btn btn-sm" onClick={props.dummyPlanningPopup} >
                        <i className="fa fa-bookmark" style={IconsStyle("#ffffff")}></i>
                    </button>

                    <div title={lang.selected_content_text_planning_footer} className="iconBase2" >
                        <span id="planning-selected-count" className="footerText">{selectedPlanningItemCount}&nbsp;{lang.selected_label}</span>
                    </div>

                    <div title={lang.copied_content_text_planning_footer} className="iconBase2" >
                        <span className="footerText">{plannerCopiedItemsCount}&nbsp;{lang.copied_label}</span>
                    </div>

                    {activteUsers?.map((item) => {
                        return <Avatar data={item} />
                    })}

                    <label className="footerText" style={{marginLeft:"20px", marginTop:"8px"}}>{lang.start_type_label}:</label>
                    <DropDownList
                        value={props.startType}
                        className="mt-1 mr-2"
                        style={{
                            width: "100px",
                            marginLeft: "5px",
                            height:"25px"
                        }}
                        data={startTypes}
                        onChange={(e) => {
                            props.onStartTypeChange(e.value);
                        }}
                    />
                    
                    <label className="footerText" style={{marginTop:"8px"}}>{lang.duration_type_label}:</label>
                    <DropDownList
                        value={props.durationType}
                        className="mt-1 mr-2"
                        style={{
                            width: "100px",
                            marginLeft: "5px",
                            height:"25px"
                        }}
                        data={durationTypes}
                        onChange={(e) => {
                            props.onDurationTypeChange(e.value);
                        }}
                    />
                </div>
            </div>
            <div className="col-3 mt-2" style={{ textAlign: "right" }}>
                <div className="row">
                    <div className="col">
                        <span className="footerText">{statusMsg}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {showOverlapGapPopup && (<CheckPlanningOverlapOrGapPopup onClose={() => setShowOverlapGapPopup(false)}/>)}
    </>;
}




export default memo(PlaningFooter);
